import { getNitroOrigin } from "./getNitroOrigin.js";
export function useNitroOrigin(e) {
  return getNitroOrigin(e);
}
